const addEpsilon = (value) => {
    return value < 0 ? value - Number.EPSILON : value + Number.EPSILON;
};
export const round = (value, places, midpointRounding = "toEven") => {
    const multiplier = 10 ** places;
    switch (midpointRounding) {
        case "toPositiveInfinity":
            return Math.round(addEpsilon(value) * multiplier) / multiplier;
        case "awayFromZero":
            var rounded = Math.round(Math.abs(addEpsilon(value)) * multiplier) / multiplier;
            return rounded * (value < 0 ? -1 : 1);
        //https://stackoverflow.com/a/3109234
        case "toEven":
            var n = +(places ? value * multiplier : value).toFixed(8); // Avoid rounding errors
            var i = Math.floor(n);
            var f = n - i;
            var e = 1e-8; // Allow for rounding errors in f
            var r = f > 0.5 - e && f < 0.5 + e ? (i % 2 === 0 ? i : i + 1) : Math.round(n);
            return places ? r / multiplier : r;
    }
};
export const addOrdinalSuffix = (index) => {
    const suffices = ["th", "st", "nd", "rd"];
    const remainder = index % 100;
    return (index + (suffices[(remainder - 20) % 10] || suffices[remainder] || suffices[0]));
};
export const convertDistance = (from, to, distance) => {
    if (from === to)
        return distance;
    if (from === "miles")
        return distance * 1.609344;
    return distance * 0.621371192;
};
export const map = (value, from, to) => ((value - from.min) * (to.max - to.min)) / (from.max - from.min) + to.min;
